const ITEMS = [
  "Rentabilidad bruta",
  "Cash flow",
  "ROI",
  "Cash-on-cash",
  "ITP",
  "IBI",
  "LTV",
  "PisoScore",
  "Comprar vs alquilar",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span
          className={`whitespace-nowrap px-6 font-display text-3xl font-extrabold tracking-tight sm:text-4xl ${
            i % 2 === 0 ? "text-outline-navy" : "text-slate-900/90"
          }`}
        >
          {item}
        </span>
        <span className="h-2.5 w-2.5 rotate-45 rounded-[3px] bg-emerald-500" aria-hidden="true" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="marquee-section" className="overflow-hidden border-y border-slate-200/80 bg-white py-7" aria-hidden="true">
    <div className="animate-inmo-marquee flex w-max">
      <Row />
      <Row />
    </div>
  </section>
);
